/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboBranchConfigBadRequestResponse,
  BboBranchConfigFailureResponseResponse,
  BboBranchConfigForbiddenResponse,
  BboBranchConfigUnauthorizedResponse,
  CountTypeDetailResponseResponse,
  NotFoundResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get the list of currency based on count type, currency code and currency name
 * @summary Get the list of currency based on count type, currency code and currency name.
 */
export const getBranchCountTypeCurrency = (signal?: AbortSignal) => {
  return customInstance<CountTypeDetailResponseResponse>({
    url: `/BboBranchConfigService/v1/count-type-currency`,
    method: 'get',
    signal,
  });
};

export const getGetBranchCountTypeCurrencyQueryKey = () => {
  return [`/BboBranchConfigService/v1/count-type-currency`] as const;
};

export const getGetBranchCountTypeCurrencyQueryOptions = <
  TData = Awaited<ReturnType<typeof getBranchCountTypeCurrency>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | NotFoundResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getBranchCountTypeCurrency>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBranchCountTypeCurrencyQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBranchCountTypeCurrency>>> = ({
    signal,
  }) => getBranchCountTypeCurrency(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBranchCountTypeCurrency>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBranchCountTypeCurrencyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBranchCountTypeCurrency>>
>;
export type GetBranchCountTypeCurrencyQueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | NotFoundResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary Get the list of currency based on count type, currency code and currency name.
 */
export const useGetBranchCountTypeCurrency = <
  TData = Awaited<ReturnType<typeof getBranchCountTypeCurrency>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | NotFoundResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getBranchCountTypeCurrency>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBranchCountTypeCurrencyQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
